module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABPUlEQVR4AbSUO0pDQRSGfaEiugIRESxcgVtwCQoiCiKInYWVFoIuQQsbxQeoS9BNWFlYqWAjIaQISSAhJN9/uBNOHneYIgn/N+fcM+f+M8MdMjE2pJ832sKzAS1H2eWhXslqTeI2mLzRM5VbkKG4Jp+HXdCzeCOfA+VXxCcweSMVLhleMx6JVXiAUHsn/wU9nxM78kZ1qssQtEgyA17aTaitMFEDkzeyghumyH9gAQpwAt+gBQndihmVaJ2GPyiCjC6IX9CnmJG+yhJvaDdrxA3QcdaJkr6iohEz+qfjBlZB+mDYhzuQdHRFI2b0SccheOl6HGeFZKOsPzckHy3XYdBE7GiD+nNrIzHSndH1z121Z0KXdTbUend0ysRmImf0jYPJG+1QOYCXRI7o2wOTN9JfwiRVrZKC3r2n39QGAAD//xkgKHcAAAAGSURBVAMAD61AJYTcLkkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/navBzzx.png
// module id = /fJE
// module chunks = 95